import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportsService } from 'src/app/services/reports.service';
import { ToastService } from 'src/app/toast/toast.service';
import { Modal } from 'bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-progress-and-development',
  templateUrl: './progress-and-development.component.html',
  styleUrls: ['./progress-and-development.component.scss']
})
export class ProgressAndDevelopmentComponent implements OnInit {

  sanctionForm!: FormGroup;
  isSubmitted = false;
  investmentData: any[] = [];
  blockList: any[] = [];
  societyList: any[] = [];
  progressForm!: FormGroup;
  editId: number | null = null;
  edit = false;
  UserDetails: any;
  selectedFile: File | null = null;
  uploadedFileName: string | null = null;
  challanPDFPath: string | null = null;
  financialYear: string | null = null;
  blockId: number | null = null;
  societyTypeList: any[] = [];
  isViewMode = false;
  headData: any[] = [];

  reportData: any
  constructor(private fb: FormBuilder,
    private reportService: ReportsService,
    private toastService: ToastService, private cd: ChangeDetectorRef,
    private router: Router,
    private authService: AuthService,
    private ActivatedRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.sanctionForm = this.fb.group({
      id: [0],
      headAccount: ['', Validators.required],
      date: ['', Validators.required],
      sanction: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.maxLength(10)]],
      amountSanction: ['', [Validators.required, Validators.pattern(/^[0-9]+$/), Validators.maxLength(10)]],
      dataMonth: [0],
      financialYear: [''],
      blockID: [0]
    });


    this.progressForm = this.fb.group({
      id: [0],
      blockOfficeId: [null, Validators.required],
      financialYear: [''],
      dataMonth: [0],
      documentFileName: [''],
      coopSocieties: ['', Validators.required],
      coopSocietiesType: ['', Validators.required],

      // Only numbers (max length 10)
      govtInvestment: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],

      // Govt. Challan
      gDate: ['', Validators.required],
      gChallanNo: ['', Validators.required],
      gAmount: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      gUploadChallan: ['', Validators.required],
      govFileName: [''],

      // Numbers only fields
      tGovtShare: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      tGovtInvestment: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      outstandingDividendPrevious: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      tAmountDevidendDeposite: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      outstandingDividendEnd: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],

      // Coop Bank
      coopBankDate: ['', Validators.required],
      coopBankChallanNo: ['', Validators.required],
      coopBankAmount: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      coopBankUploadChallan: ['', Validators.required],
      coopBankFileName: [''],

      // Coop Societies
      coopSocietiesDate: ['', Validators.required],
      coopSocietiesChallanNo: ['', Validators.required],
      coopSocietiesAmount: [
        0,
        [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
      ],
      coopSocietiesUploadChallan: ['', Validators.required],
      coopSocietiesFileName: ['']
    });
    //   this.ActivatedRoute.queryParams.subscribe(params => {
    //   if (params['data']) {
    //     this.reportData = JSON.parse(params['data']);
    //     this.editRow(this.reportData);
    //   }
    // });

    this.ActivatedRoute.queryParams.subscribe(params => {
      this.reportData = params['data'] ? JSON.parse(params['data']) : null;
      
      this.isViewMode = params['viewMode'] === 'true'; // ✅ check flag
      if (this.reportData)

            
    this.getSocietyType(null);
      ;
      // if (data) {
      //   this.expenditureForm.patchValue(data);
      // }

      if (this.isViewMode) {
        this.progressForm.disable(); // ✅ disable entire form
      }
    });


    let user: any = this.authService.currentUserValue;
    this.UserDetails = user;


    // this.createForm();
    this.GetBlock();


    this.ActivatedRoute.queryParams.subscribe(params => {
      this.financialYear = params['financialYear']
        ? params['financialYear']
        : this.reportData?.financialYear ?? null;

      this.blockId = params['blockOffice']
        ? Number(params['blockOffice'])
        : Number(this.reportData?.blockOfficeId ?? 0);

    });
    this.progressForm.patchValue({
      blockOfficeId: this.blockId,
      coopSocietiesType: this.reportData?.coopSocietiesType

    });

    this.progressForm.get('coopSocietiesType')?.valueChanges.subscribe(value => {
      const id = Number(value);
      if (id) {
        this.getSociety({ target: { value: id } }, false);
      }
    });


    this.getInvestmentData();
    this.getHeadData();

  }


  //   createForm(): void {
  //   this.progressForm = this.fb.group({
  //     id: [0],
  //     blockOfficeId: [null, Validators.required],
  //     financialYear: [''],
  //     dataMonth: [0],
  //     documentFileName: [''],
  //     coopSocieties: ['', Validators.required],
  //     coopSocietiesType: ['', Validators.required],

  //     // Only numbers (max length 10)
  //     govtInvestment: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],

  //     // Govt. Challan
  //     gDate: ['', Validators.required],
  //     gChallanNo: ['', Validators.required],
  //     gAmount: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     gUploadChallan: ['', Validators.required],
  //     govFileName: [''],

  //     // Numbers only fields
  //     tGovtShare: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     tGovtInvestment: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     outstandingDividendPrevious: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     tAmountDevidendDeposite: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     outstandingDividendEnd: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],

  //     // Coop Bank
  //     coopBankDate: ['', Validators.required],
  //     coopBankChallanNo: ['', Validators.required],
  //     coopBankAmount: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     coopBankUploadChallan: ['', Validators.required],
  //     coopBankFileName: [''],

  //     // Coop Societies
  //     coopSocietiesDate: ['', Validators.required],
  //     coopSocietiesChallanNo: ['', Validators.required],
  //     coopSocietiesAmount: [
  //       0,
  //       [Validators.required, Validators.min(0), Validators.pattern('^[0-9]*$'), Validators.maxLength(10)]
  //     ],
  //     coopSocietiesUploadChallan: ['', Validators.required],
  //     coopSocietiesFileName: ['']
  //   });
  //     //   this.ActivatedRoute.queryParams.subscribe(params => {
  //     //   if (params['data']) {
  //     //     this.reportData = JSON.parse(params['data']);
  //     //     this.editRow(this.reportData);
  //     //   }
  //     // });

  //     this.ActivatedRoute.queryParams.subscribe(params => {
  //     this.reportData = params['data'] ? JSON.parse(params['data']) : null;
  //     this.isViewMode = params['viewMode'] === 'true'; // ✅ check flag
  //     if(this.reportData)
  //     this.editRow(this.reportData);
  //     // if (data) {
  //     //   this.expenditureForm.patchValue(data);
  //     // }

  //     if (this.isViewMode) {
  //       this.progressForm.disable(); // ✅ disable entire form
  //     }
  //   });
  // }



  allowNumbersOnly(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  GetBlock() {
    const obj = {
      blockId: 0,
      circleId: this.UserDetails?.iCircleId
    };

    this.reportService.GetBlock(obj).subscribe({
      next: (res: any) => {
        if (res?.data?.block) {
          this.blockList = res.data.block;

          // ✅ Prefill the dropdown if blockId is present and valid
          const foundBlock = this.blockList.find(b => b.iBlockId === this.blockId);
          if (foundBlock) {
            this.progressForm.get('blockOfficeId')?.setValue(this.blockId);

            // ✅ Automatically trigger getSociety() for prefilled block
            // this.getSociety({ target: { value: this.blockId } }, false);
          }
        }
      },
      error: (err: any) => {
        console.error('Error fetching block list:', err);
      }
    });
  }

  getSociety(event: any, prefill: boolean) {
    const selectedValue = Number(
      prefill
        ? event?.target?.value
        :this.progressForm.get('coopSocietiesType')?.value
    );

    if (!selectedValue) return;

    this.reportService.getSocieties(selectedValue).subscribe(
      (res: any) => {
        this.societyList = res?.data ?? [];
     prefill && this.editRow(this.reportData)
      },
      (error: any) => {
        console.error(error);
        this.societyList = [];
      }
    );
  }


  getSocietyType(event: any) {
    this.reportService.getSocietyType().subscribe(
      (res: any) => {
        this.societyTypeList = res?.data ?? [];
          var type = this.societyTypeList.find(st => st.typeName === this.reportData.coopSocietiesType);
        // this.getSociety(null, true);
        this.getSociety({ target: { value: type?.id } }, true);
  
      },
      (error: any) => {
        console.error('Error fetching society types:', error);
        this.societyTypeList = [];
      }
    );
  }

  onFileChange(event: any, controlName: string): void {
    const file: File = event.target.files[0];
    if (!file) return;

    const fileSizeInMB = file.size / (1024 * 1024);
    const allowedExtensions = ['pdf'];
    const ext = this.getFileExtension(file.name);

    if (!allowedExtensions.includes(ext)) {
      this.toastService.showError('Invalid file type. Only PDF allowed.');
      return;
    }

    if (fileSizeInMB > 2) {
      this.toastService.showError('File size must be ≤ 2 MB');
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const base64String = reader.result as string;

      // Dynamically set correct file name field
      let fileNameControl = '';
      if (controlName === 'gUploadChallan') fileNameControl = 'govFileName';
      else if (controlName === 'coopBankUploadChallan') fileNameControl = 'coopBankFileName';
      else if (controlName === 'coopSocietiesUploadChallan') fileNameControl = 'coopSocietiesFileName';

      this.progressForm.patchValue({

        [fileNameControl]: file.name,     // correct filename
        [controlName]: base64String      // base64
      });

    };

    reader.readAsDataURL(file);
  }



  convertToBase64(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.challanPDFPath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  // getFileExtension(fileName: string): string {
  //   const idx = fileName.lastIndexOf('.');
  //   return idx !== -1 ? fileName.substring(idx + 1).toLowerCase() : '';
  // }

  getFileExtension(fileName: string): string {
    const idx = fileName.lastIndexOf('.');
    return idx !== -1 ? fileName.substring(idx + 1).toLowerCase() : '';
  }


  saveFormDetail(): void {
    this.isSubmitted = true;

    if (this.progressForm.invalid) {
      this.progressForm.markAllAsTouched();
      return;
    }

    const formData = this.progressForm.getRawValue();
    // let societyType = this.societyList.find(st => st.id ===Number(formData.coopSocieties));
    const finalObj = {
      id: this.edit ? this.editId : 0,
      blockOfficeId: formData.blockOfficeId,
      // financialYear: this.financialYear,
      financialYear: this.edit ? formData.financialYear : this.financialYear,
      dataMonth: new Date().getMonth() + 1,
      coopSocieties: formData.coopSocieties,
      coopSocietiesType: formData.coopSocietiesType,
      govtInvestment: Number(formData.govtInvestment) || 0,

      // Govt. Challan
      gDate: formData.gDate,
      gChallanNo: formData.gChallanNo,
      gAmount: Number(formData.gAmount) || 0,
      gUploadChallan: formData.gUploadChallan, // Base64
      govFileName: formData.govFileName,       // File name

      // Totals
      tGovtShare: Number(formData.tGovtShare) || 0,
      tGovtInvestment: Number(formData.tGovtInvestment) || 0,
      outstandingDividendPrevious: Number(formData.outstandingDividendPrevious) || 0,
      tAmountDevidendDeposite: Number(formData.tAmountDevidendDeposite) || 0,
      outstandingDividendEnd: Number(formData.outstandingDividendEnd) || 0,

      // Coop Bank
      coopBankDate: formData.coopBankDate,
      coopBankChallanNo: formData.coopBankChallanNo,
      coopBankAmount: Number(formData.coopBankAmount) || 0,
      coopBankUploadChallan: formData.coopBankUploadChallan, // Base64
      coopBankFileName: formData.coopBankFileName,           // File name

      // Coop Societies
      coopSocietiesDate: formData.coopSocietiesDate,
      coopSocietiesChallanNo: formData.coopSocietiesChallanNo,
      coopSocietiesAmount: Number(formData.coopSocietiesAmount) || 0,
      coopSocietiesUploadChallan: formData.coopSocietiesUploadChallan, // Base64
      coopSocietiesFileName: formData.coopSocietiesFileName            // File name
    };


    this.reportService.addProgressDevelopmentData(finalObj).subscribe({
      next: (res) => {
        if (res?.status === 200) {
          this.toastService.showSuccess(res.message);
          // this.router.navigate(['/reports/progressReport']);
          this.goToReportPage();
        }
      },
      error: () => {
        this.toastService.showError('Something went wrong while saving.');
      }
    });
  }




  editRow(row: any): void {

    this.editId = row?.id || 0;
    this.edit = true;
 
    
   var type = this.societyTypeList.find(st => st.typeName === row.coopSocietiesType);
   
    this.progressForm.patchValue({
      id: row.id,
      blockOfficeId: Number(row.blockOfficeId),
      financialYear: row.financialYear,
      dataMonth: Number(row.dataMonth),
      // documentFileName: row.documentFileName,
      coopSocieties: row.coopSocieties,
      coopSocietiesType: type?.id || '',
      govtInvestment: Number(row.govtInvestment),
      gDate: row.gDate ? row.gDate.split('T')[0] : '',
      gChallanNo: row.gChallanNo,
      gAmount: Number(row.gAmount),
      // gUploadChallan: row.gUploadChallan,
      tGovtShare: Number(row.tGovtShare),
      tGovtInvestment: Number(row.tGovtInvestment),
      outstandingDividendPrevious: Number(row.outstandingDividendPrevious),
      tAmountDevidendDeposite: Number(row.tAmountDevidendDeposite),
      outstandingDividendEnd: Number(row.outstandingDividendEnd),
      coopBankDate: row.coopBankDate ? row.coopBankDate.split('T')[0] : '',
      coopBankChallanNo: row.coopBankChallanNo,
      coopBankAmount: Number(row.coopBankAmount),
      // coopBankUploadChallan: row.coopBankUploadChallan,
      coopSocietiesDate: row.coopSocietiesDate ? row.coopSocietiesDate.split('T')[0] : '',
      coopSocietiesChallanNo: row.coopSocietiesChallanNo,
      coopSocietiesAmount: Number(row.coopSocietiesAmount),
      // coopSocietiesUploadChallan: row.coopSocietiesUploadChallan
    });

  }



  get f() {
    return this.sanctionForm.controls;
  }

  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }



  onSubmit(): void {
    // this.isSubmitted = true;
    if (this.sanctionForm.invalid) {
      this.sanctionForm.markAllAsTouched();
      return;
    }
    const formData = this.sanctionForm.getRawValue();

    const finalObj = {
      id: 0,
      headAccount: formData.headAccount || '',
      date: formData.date ? new Date(formData.date).toISOString() : null,
      sanction: Number(formData.sanction) || 0,
      amountSanction: Number(formData.amountSanction) || 0,
      dataMonth: formData.dataMonth ? formData.dataMonth : new Date().getMonth() + 1,
      financialYear: this.financialYear,
      blockID: this.blockId
    };
    this.reportService.addInvestment(finalObj).subscribe(
      (res: any) => {
        if (res) {
          if (res?.status === 200) {
            this.toastService.showSuccess(res.message || 'Record saved successfully!');
            this.sanctionForm.reset();
            this.isSubmitted = false;
            this.hideModal('InvestmentMadeDuringMonth');
            this.getInvestmentData();
          } else {
            this.toastService.showError(res.message || 'Something went wrong.');
          }
        }
      },
      (error: any) => {
        this.toastService.showError('Server error! Please try again later.');
      }
    );
  }


  getInvestmentData() {
    let obj = {
      "blockId": this.blockId,
      "financialYear": this.financialYear
    }


    this.reportService.getInvestmentData(obj).subscribe((res: any) => {
      if (res) {
        if (res && res?.data && res?.data.length > 0) {
          this.investmentData = res?.data;
        } else {
          this.investmentData = []
          // this.toastService.showInfo('NO Data Found!')
        }
      }
    },
      (error: any) => {
      }
    );
  }

  deleteRow(id: any) {
    this.reportService.deleteinvestment(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.getInvestmentData();
        }
      }
    },
      (error: any) => {
      }
    );
  }

  deleteIndex: any = 0;
  verifyAuditConducted(id: any) {

    this.reportService.verifyaAuditConducted(id).subscribe((res: any) => {
      if (res) {
        if (res?.status == 200) {
          this.toastService.showSuccess(res.message);
          this.deleteIndex = 0;
          // this.hideModal();
          this.getInvestmentData();
        }
      }
    },
      (error: any) => {
      }
    );
  }
  openModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.show();

    }
  }

  goToReportPage() {
    this.router.navigate(
      ['/reports/progressReport'],
      {
        queryParams: {
          financialYear: this.financialYear,
          blockOffice: this.blockId
        }
      }
    );
  }

  hideModal(model: any) {
    const modalElement = document.getElementById(model);
    if (modalElement) {
      const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
      modalInstance.hide();
    }
  }

  getHeadData() {
    this.reportService.getHeadData().subscribe((res: any) => {
      if (res) {
        if (res && res?.data && res?.data.length > 0) {

          this.headData = res?.data;
        } else {
          this.headData = []
          // this.toastService.showInfo('NO Data Found!')
        }
      }
    },
      (error: any) => {
      }
    );
  }


}
